import auth from './auth'
import user from './user'
import dom from './dom'
import toast from './toast'
import news from './news'
import profilePosts from './profilePosts'
import contracts from './contracts'
import contract from './contract'
import paymentSchedules from './paymentSchedules'
import paymentHistories from './paymentHistories'
import carInsurances from './carInsurances'
import carRegistrationStatuses from './carRegistrationStatuses'
import notifications from './notifications'
import unreadNotifications from './unreadNotifications'
import payments from './payments'
import payment from './payment'
import accountHistories from './accountHistories'
import earlyPayment from './earlyPayment'
import earlyPayments from './earlyPayments'

export default {
  auth,
  user,
  dom,
  toast,
  news,
  profilePosts,
  contracts,
  contract,
  paymentSchedules,
  paymentHistories,
  carInsurances,
  carRegistrationStatuses,
  notifications,
  unreadNotifications,
  payments,
  payment,
  accountHistories,
  earlyPayment,
  earlyPayments
}
